import React, { useMemo } from 'react';
import { useFragment } from '@apollo/client';

import { convertProductProps } from '@utils/products';
import {
  ProductDetailsOwnerProducts,
  ProductDetailsOwnerProductsSkeleton,
} from '@components/product/ProductDetailsOwnerProducts';

import {
  ProductDetailsOwnerProductsFragment,
  ProductDetailsOwnerProductsFragmentDoc,
  useProductDetailsOwnerProductsQuery,
} from './gql/graphql.v3.generated';

type Product = {
  __typename?: 'ProductDetails',
  id: number,
}

interface Props {
  className?: string,
  productId: number,
  product?: Product,
}

export const ProductDetailsOwnerProductsContainer: React.FC<Props> = ({
  className,
  productId,
  product,
}) => {
  const { data: productData } = useFragment<ProductDetailsOwnerProductsFragment>({
    fragment: ProductDetailsOwnerProductsFragmentDoc,
    from: product || null,
  });

  const { data, loading } = useProductDetailsOwnerProductsQuery({
    variables: {
      productId,
      perPage: 5,
    },
    context: {
      batch: true,
    },
  });

  const ownerUsername = productData?.seller?.username;
  const products = useMemo(() => {
    return data?.productDetailsOwnerProducts?.map((product) => {
      if (product) {
        return convertProductProps(product);
      }

      return null;
    }).filter((product) => !!product);
  }, [data?.productDetailsOwnerProducts]);

  if (loading) {
    return (
      <div className={className}>
        <ProductDetailsOwnerProductsSkeleton />
      </div>
    );
  }

  if (products?.length && ownerUsername) {
    return (
      <ProductDetailsOwnerProducts
        className={className}
        products={products.slice(0, 4)}
        username={ownerUsername}
        hasMore={products.length > 4}
      />
    );
  }

  return null;
};
